import { tv, cn } from '@costar-ui/cosmos';
import React__default from 'react';
import { ArticlePromoWithImage, ImageOrientation } from '../article-promo/article-promo-with-image.esm.js';
import { ArticlePreview } from '../atoms/article-preview/article-preview.esm.js';
import { ArticleTitle, ArticleTitleVariants } from '../atoms/article-title/article-title.esm.js';
import { CategoryBar } from '../atoms/category-bar/category-bar.esm.js';

// import {
//   ArticlePreview,
//   ArticleTitle,
//   ArticleTitleVariants,
//   CategoryBar
// } from '../atoms'
// import type { ArticleLayoutProps } from '../interfaces'

/**
 * @description
 * **A molecule component that returns the several articles with images in a horizontal pattern with scrollable overfflow on mobile**
 *
 * Requires following element props
 * >- articles - an array of object with the following properties: articleImage, articleTitleLink, categoryLink
 * >- layoutVariant - 3 | 4 - component currently supports 3 or 4 columns
 *
 *
 * @example
 * <HorizontalArticlesWithImages
 *    articles={articles}

 * />
 */
var layoutVariants = tv({
  base: 'grid gap-4 sm:gap-6 lg:gap-8',
  variants: {
    layoutVariant: {
      '3-cols': 'sm:grid-cols-3 ',
      '4-cols': 'sm:grid-cols-2 lg:grid-cols-4 sm:max-lg:grid-rows-2'
    }
  },
  defaultVariants: {
    layoutVariant: '3-cols'
  }
});
var HorizontalArticlesWithImages = function HorizontalArticlesWithImages(_ref) {
  var articles = _ref.articles,
    sectionId = _ref.sectionId,
    layoutVariant = _ref.layoutVariant,
    _ref$hasPreview = _ref.hasPreview,
    hasPreview = _ref$hasPreview === void 0 ? false : _ref$hasPreview;
  var numArticlesExpected;
  switch (layoutVariant) {
    case '4-cols':
      numArticlesExpected = 4;
      break;
    case '3-cols':
    default:
      numArticlesExpected = 3;
      break;
  }
  var articleListItems = articles.slice(0, numArticlesExpected).map(function (a, i) {
    var category = /*#__PURE__*/React__default.createElement(CategoryBar, null, a.categoryLink);
    var title = /*#__PURE__*/React__default.createElement(ArticleTitle, {
      articleTitleVariant: ArticleTitleVariants.ArticleTitleMedium
    }, a.articleTitleLink);
    var image = /*#__PURE__*/React__default.createElement("div", {
      className: "relative aspect-3/2 w-full"
    }, a.articleImage);
    var preview = hasPreview && /*#__PURE__*/React__default.createElement(ArticlePreview, {
      className: "line-clamp-2 text-p-14 lg:text-p-16 max-sm:hidden"
    }, a.articlePreviewLink);
    return /*#__PURE__*/React__default.createElement("li", {
      key: "".concat(sectionId, "-article-").concat(i),
      className: "col-span-1"
    }, /*#__PURE__*/React__default.createElement("article", null, /*#__PURE__*/React__default.createElement(ArticlePromoWithImage, {
      imageElement: image,
      imageOrientation: ImageOrientation.Top,
      categoryBarElement: category,
      articleTitleElement: title,
      articlePreviewElement: preview
    })));
  });
  return /*#__PURE__*/React__default.createElement("ol", {
    className: cn(layoutVariants({
      layoutVariant: layoutVariant
    })),
    "automation-id": "".concat(sectionId, "-article-list")
  }, articleListItems);
};

export { HorizontalArticlesWithImages };
//# sourceMappingURL=horizontal-articles-with-images.esm.js.map
